import { useAuth0 } from '@auth0/auth0-react';
import React from 'react'
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 95vh;
  /* display: flex; */
  border: 1px solid lightgray;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SessionExpired = () => {
    const { logout } = useAuth0();
    return (
        <Container><h1>This session has expired. Click the following link to <u><a href='#' onClick={() => {
            logout({ returnTo: window.location.origin });
        }}>login</a></u> again.</h1></Container>
    )
}

export default SessionExpired